import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6acca866"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acca866')) {
      api.createRecord('6acca866', component.options)
    } else {
      api.reload('6acca866', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6acca866", function () {
      api.rerender('6acca866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign-template/index.vue"
export default component.exports